import { Outlet, Link } from 'react-router';
// import logo from '../../imports/logo-MORROCARS.png';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import ScrollToTop from "../components/ScrollToTop";

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-[#F5F7FA] flex flex-col">
    {/* //   <div className="flex items-center justify-between px-6 py-4 bg-white border-b border-[#E5E7EB]">
    //     <Link to="/">
    //       <img src={logo} alt="MORROCARS" className="h-10 w-auto" />
    //     </Link>
    //     <Link to="/" className="text-[#2D323A] hover:text-[#1E6DFF] transition-colors text-sm">
    //       ← Back to Home
    //     </Link>
    //   </div> */}
    <ScrollToTop/>
    <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <Outlet />
      </div>
      <Footer/>
     </div>
  );
}
